import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { useScrollToSection } from '../hooks/useScrollToSection';
import { config } from '../config/config';

export function Footer() {
  const { scrollToSection } = useScrollToSection();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300 relative overflow-hidden">
      <div className="absolute inset-0 opacity-40">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(148,163,184,0.12),transparent_28%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(15,23,42,0.2),rgba(15,23,42,0.9))]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 mb-12">
          <div className="lg:col-span-2">
            <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-left">
              <div className="text-3xl font-semibold text-white tracking-tight">Free Zone</div>
              <div className="text-sm uppercase tracking-[0.35em] text-slate-400 mt-2">Logistic Park</div>
            </button>

            <p className="text-slate-400 mt-6 mb-8 max-w-md leading-relaxed">
              Desarrollo industrial y logístico para empresas que buscan escala, orden operativo
              y una plataforma confiable para crecer.
            </p>

            <div className="space-y-3">
              <a href={`tel:${config.contact.phone.replace(/\s/g, '')}`} className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <span className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <Phone className="h-4 w-4" />
                </span>
                <span className="text-sm">{config.contact.phone}</span>
              </a>
              <a href={`mailto:${config.contact.email}`} className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <span className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <Mail className="h-4 w-4" />
                </span>
                <span className="text-sm">{config.contact.email}</span>
              </a>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(config.contact.address)}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors"
              >
                <span className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                  <MapPin className="h-4 w-4" />
                </span>
                <span className="text-sm">
                  {config.contact.address}
                </span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white mb-4 font-semibold text-lg">Empresa</h3>
            <ul className="space-y-3">
              {[
                { label: 'Sobre Nosotros', id: 'about' },
                { label: 'Características', id: 'features' },
                { label: 'Servicios', id: 'services' },
                { label: 'Ubicación', id: 'location' },
              ].map((link) => (
                <li key={link.id}>
                  <button onClick={() => scrollToSection(link.id)} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white mb-4 font-semibold text-lg">Recursos</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Documentación</li>
              <li>Preguntas Frecuentes</li>
              <li>Blog</li>
              <li>Casos de Éxito</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white mb-4 font-semibold text-lg">Legal</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Privacidad</li>
              <li>Términos de Uso</li>
              <li>Política de Cookies</li>
              <li>Aviso Legal</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">© {currentYear} Free Zone Logistic Park. Todos los derechos reservados.</p>

          <div className="flex items-center gap-3">
            {[
              { icon: Linkedin, href: config.social.linkedin, label: 'LinkedIn' },
              { icon: Facebook, href: config.social.facebook, label: 'Facebook' },
              { icon: Instagram, href: config.social.instagram, label: 'Instagram' },
            ].map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:text-white transition-colors"
              >
                <social.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>
      </div>

    </footer>
  );
}
